import all from './all';

export default {
    all,
};
